import axios from "axios";
import { setToken } from "../actions/authActions";
import { toastMessage } from "../helper";
import store from "../store";
const env: any = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV
  : "local";
let sessionExpiryToast = false;
//  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("token")}`;
// if()
// axios.defaults.headers.common['user'] = "Abhi" ;
// axios.defaults.headers.common['test'] = "Abhi" ;

export const axiosAuth = axios.create({
  paramsSerializer: {
    encode: (param: string) =>
      // Sample implementation of query string building
      encodeURIComponent(param),
  },
});

axiosAuth.interceptors.request.use(
  (conf) => {
    // conf.timeout = APP_DATA.API_TIMEOUT;
    if (localStorage.getItem("token")) {
      conf.headers.Authorization = `${localStorage.getItem("token")}`;
    }
    let user = localStorage.getItem("user");
    if (user) {
      conf.headers.userId = JSON.parse(user).owner;
      conf.headers.username = JSON.parse(user).email;
    }
    if (conf.params) {
      conf.params.protocol = localStorage.getItem("protocol") || "iso";
    }
    let company = localStorage.getItem("company");
    if (company && env === "local") {
      conf.headers.companyId = JSON.parse(company).id;
    }
    return conf;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosAuth.interceptors.response.use(
  (next) => {
    return Promise.resolve(next);
  },
  (error) => {
    if (
      !(
        error.response?.data?.message?.includes("UserName") ||
        error.response?.data?.message?.includes("password")
      )
    ) {
      handleError(error);
    }
    return Promise.reject(error);
  }
);

const handleError = (error: {
  message: string;
  request: { status: number };
  response: { data: { message: string }; status: number };
}) => {
  try {
    // store.dispatch(errorLogging(true));
    // store.dispatch(errorLoggingMsg(error.response?.data?.message));
    // error.response?.data?.message?.includes("PW-Ingress Auth Error !!")
    if (
      error?.response?.status === 403 ||
      error.response?.data?.message?.includes("PW-Ingress Auth Error !!")
    ) {
      if (!sessionExpiryToast) {
        sessionExpiryToast = true;
        setTimeout(() => {
          sessionExpiryToast = false;
        }, 2000);
        toastMessage("Session Expired !! Please Login Again", "info");
        localStorage.clear();
        store.dispatch(setToken(null));
      }
    } else if (error?.response?.status === 500) {
      error.response.data.message = "Request failed with status code 500";
    }
  } catch (e) {
    // store.dispatch(errorLogging(true));
    // store.dispatch(errorLoggingMsg(e));
  }
};
